import { render, staticRenderFns } from "./SandwichRelease.vue?vue&type=template&id=53dcc029"
import script from "./SandwichRelease.vue?vue&type=script&lang=js"
export * from "./SandwichRelease.vue?vue&type=script&lang=js"
import style0 from "./SandwichRelease.vue?vue&type=style&index=0&id=53dcc029&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports